import Enum from '../types/Enum';

export default class Color extends Enum<{ r: number, g: number, b: number, a: number }> {
  static BUTTON_DEFAULT_BACKGROUND = new Color({ r: 255, g: 255, b: 255, a: 1 }); // #fff
  static BUTTON_DEFAULT_BORDER = new Color({ r: 221, g: 221, b: 221, a: 1 }); // #DDD
  static BUTTON_DEFAULT_COLOR = new Color({ r: 51, g: 51, b: 51, a: 1 }); // #333
  static BUTTON_DEFAULT_HOVER = new Color({ r: 242, g: 242, b: 242, a: 1 }); // #f2f2f2

  static BUTTON_PRIMARY_BACKGROUND = new Color({ r: 0, g: 189, b: 112, a: 1 }); // #00BD70
  static BUTTON_PRIMARY_BORDER = new Color({ r: 0, g: 189, b: 112, a: 1 }); // #00BD
  static BUTTON_PRIMARY_COLOR = new Color({ r: 255, g: 255, b: 255, a: 1 }); // #FFF
  static BUTTON_PRIMARY_HOVER = new Color({ r: 0, g: 164, b: 97, a: 1 }); // #00a461

  static BUTTON_DARK_BACKGROUND = new Color({ r: 0, g: 0, b: 0, a: 0.25 }); // #000
  static BUTTON_DARK_BORDER = new Color({ r: 0, g: 0, b: 0, a: 0 }); // transparent
  static BUTTON_DARK_COLOR = new Color({ r: 255, g: 255, b: 255, a: 1 }); // #FFF
  static BUTTON_DARK_HOVER = new Color({ r: 0, g: 0, b: 0, a: 0.35 }); // #000

  static BUTTON_TEXT_BACKGROUND = new Color({ r: 0, g: 0, b: 0, a: 0 }); // transparent
  static BUTTON_TEXT_COLOR = new Color({ r: 20, g: 164, b: 190, a: 1 }); // #14a4be
  static BUTTON_TEXT_HOVER = new Color({ r: 13, g: 104, b: 121, a: 1 }); // #0d6879

  static BUTTON_TEXT_LIGHT_BACKGROUND = new Color({ r: 0, g: 0, b: 0, a: 0 }); // transparent
  static BUTTON_TEXT_LIGHT_COLOR = new Color({ r: 255, g: 255, b: 255, a: 1 }); // #fff

  static BUTTON_TERTIARY_BACKGROUND = new Color({ r: 232, g: 252, b: 247, a: 1 }); // #e8fcf7
  static BUTTON_TERTIARY_BACKGROUND_HOVER = new Color({ r: 228, g: 247, b: 242, a: 1 }); // #e4f7f2
  static BUTTON_TERTIARY_BACKGROUND_PRESSED = new Color({ r: 223, g: 242, b: 237, a: 1 }); // #dff2ed
  static BUTTON_TERTIARY_COLOR = new Color({ r: 17, g: 168, b: 100, a: 1 }); // #11a864

  static isLocked = true;

  toString() {
    return `rgba(${this.value.r}, ${this.value.g}, ${this.value.b}, ${this.value.a})`;
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/styles/ButtonColor.js